import { createClient } from '@supabase/supabase-js';

import { ENV } from '@/shared/config/env';

const supabaseUrl = ENV.SUPABASE_URL;
const supabaseAnonKey = ENV.SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'famecreator-auth-session',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'implicit', // Changed from 'pkce' to 'implicit' for better OTP support
    debug: ENV.NODE_ENV === 'development', // Only enable debug logs in development
  },
});
